module.exports = __webpack_public_path__ + "img/en.73ce8c68.png";